import React, { useEffect } from 'react';
import './tnc.css';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on load
  }, []);

  return (
    <div className="terms-page">
      {/* Top Section */}
      <section className="top-section slide-down">
        <h1>Terms & Conditions</h1>
      </section>

      {/* Content Section */}
      <section className="content-section fade-in">
        <p className="slide-right">
          Welcome to Atelier by Shriji. This website is operated by Shriji Agarwal. Throughout the site, the terms “we,” “us,” and “our” refer to Atelier by Shriji.
        </p>
        <p className="slide-right">
          By visiting our website and engaging with the services we offer, you are agreeing to the terms and conditions set out below (“Terms”). These Terms may be updated from time to time, and we encourage you to review them periodically.
        </p>
        <p className="slide-right">
          These Terms apply to all users—whether you're browsing, booking a service, submitting content, or interacting with us in any other way.
        </p>
        <p className="slide-right">
          By continuing to use our website and services, you acknowledge that you have read, understood, and agreed to be bound by these Terms and our Privacy Policy. If you do not agree, we request that you refrain from using our site or placing any bookings.
        </p>
        <p className="slide-right">
          If you have any questions, please contact us at 📧 <a href="mailto:team@atelierbyshriji.in">team@atelierbyshriji.in</a>.
        </p>

        {/* Cancellations Section */}
        <h2 className="slide-left">Cancellations and Refunds</h2>
        <h3 className="slide-left">Booking &amp; Payment Policy</h3>
        <ul className="slide-right">
          <li><strong>Confirmation:</strong> A <strong>40% non-refundable booking amount</strong> is required. Confirmed services/quantities are the <strong>minimum chargeable amount</strong>. No downgrades, refunds, or adjustments are permitted after confirmation.</li>
          <li><strong>Balance Payment:</strong> Due on the appointment day. For multi-day bookings: <strong>60% on Day 1 and remaining balance on Day 2</strong>.</li>
          <li><strong>Cancellation:</strong> Client cancellations will result in the <strong>booking amount being retained as non-refundable</strong>. Cancellations from our end will receive a <strong>full refund</strong>.</li>
          <li><strong>Payments:</strong> Accepted via <strong>UPI, Bank Transfer, or Cash</strong>.</li>
          <li><strong>Rescheduling:</strong> Requests must be made <strong>60+ days before the booking date</strong>, subject to availability. A fee of <strong>20% of the advance amount or ₹5,000 (whichever is higher)</strong> applies. Any applicable price difference will be payable.</li>
          <li><strong>Timing Policy:</strong> Slots are reserved as per the confirmed ready time at the time of booking. A <strong>30-minute buffer</strong> is provided for wedding delays; extensions beyond this are not guaranteed.</li>
          <li><strong>Client Responsibilities:</strong> Clients must provide a clean, well-lit setup with basic seating and power access, and be ready on time.</li>
          <li><strong>Force Majeure:</strong> Neither party is liable for delays or cancellations due to circumstances beyond their control.</li>
        </ul>

        {/* Photography Section */}
        <h2 className="slide-left">Photography and Social Media</h2>
        <p className="slide-right">
          With your consent, we may take photos or videos during your session for our portfolio or platforms. Decline this by informing us in writing.
        </p>
        <p className="slide-right">
          All visual content is copyrighted. Unauthorized use is prohibited and legal action will be taken if violated.
        </p>

        {/* Travel Section */}
        <h2 className="slide-left">Travel and On-Location Services</h2>
        <p className="slide-right">
          Travel charges apply for out-of-area bookings. For destination bookings, travel, stay, and meals must be paid in full in advance.
        </p>

        {/* Service Policy */}
        <h2 className="slide-left">Service Policy</h2>
        <p className="slide-right">
          We use professional products tailored to your skin and preferences. Please notify us of any allergies in advance.
        </p>
        <ul className="slide-right">
          <li>We are not liable for allergic reactions or varied results.</li>
          <li>Outcomes depend on skin, environment, and aftercare.</li>
        </ul>

        {/* Liability Section */}
        <h2 className="slide-left">Liability</h2>
        <ul className="slide-right">
          <li>We are not responsible for allergic reactions, delays, or lost items.</li>
          <li>Please take care of your belongings during your appointment.</li>
        </ul>

        {/* Confidentiality */}
        <h2 className="slide-left">Confidentiality and Privacy</h2>
        <p className="slide-right">
          Your information is secure and handled as per our Privacy Policy. We do not sell or share your data without consent.
        </p>

        {/* Terms Update */}
        <h2 className="slide-left">Changes to Terms</h2>
        <p className="slide-right">
          We may modify these Terms without notice. Continued use indicates your acceptance of changes.
        </p>

        {/* Website Use */}
        <h2 className="slide-left">Website Use & Service Policy</h2>
        <p className="slide-right">
          We reserve the right to decline service to ensure safety, values, and brand integrity. Our website content may be updated or removed without notice.
        </p>

        <p className="slide-up">
          Thank you for trusting Atelier by Shriji. We're honored to be part of your special moments.
        </p>
      </section>
    </div>
  );
};

export default Terms;
